// Las imágenes propias del diseño: su firma (en lote, por bucket) y su proporción real
// (medida al cargar), para que el acomodo las dibuje enteras desde el primer frame.
import { useEffect, useMemo, useState } from 'react';
import type { ImagenPropia } from './disenoGuardado';
import { firmarPropias } from './generarEnDiseno';

export function useUrlsPropias(imagenes: ImagenPropia[]): { urls: Map<string, string>; ratios: Record<string, number> } {
  const [urls, setUrls] = useState<Map<string, string>>(new Map());
  const [ratios, setRatios] = useState<Record<string, number>>({});
  const clave = imagenes.map((i) => i.id).join('|');
  useEffect(() => {
    const faltan = imagenes.filter((i) => !urls.has(i.id));
    if (faltan.length === 0) return;
    let vivo = true;
    void firmarPropias(faltan).then((firmas) => {
      if (!vivo) return;
      setUrls((prev) => {
        const next = new Map(prev);
        for (const i of faltan) {
          const u = firmas.get(`${i.bucket}/${i.path}`);
          if (u) next.set(i.id, u);
        }
        return next;
      });
      for (const i of faltan) {
        const u = firmas.get(`${i.bucket}/${i.path}`);
        if (!u) continue;
        const img = new Image();
        img.onload = () => {
          if (vivo && img.naturalWidth > 0 && img.naturalHeight > 0) {
            setRatios((r) => ({ ...r, [i.id]: img.naturalWidth / img.naturalHeight }));
          }
        };
        img.src = u;
      }
    }).catch((e) => {
      // Sin firma la celda se queda sin `url` y no se dibuja (el acomodo la ignora);
      // no hace falta un estado de error acá: el próximo cambio de `imagenes` reintenta.
      console.error('[useUrlsPropias] firmar', e);
    });
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave]);
  return useMemo(() => ({ urls, ratios }), [urls, ratios]);
}
